module.exports = __webpack_public_path__ + "static/media/registration_image.13cf4b82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/registration_image.png
// module id = 1822
// module chunks = 0